export default function getDataExpeditionFromOtExpeditionLivraisons(
  otExpeditionLivraisons, listOtIds) {
  return otExpeditionLivraisons.map((el) => {
    const {
      id, otExpeditions,
      selected, ...adresse
    } = el;
    return {
      id,
      selected,
      otExpeditions: otExpeditions.filter(
        (ot) => listOtIds && listOtIds.includes(ot.id) || !listOtIds && ot.selected,
      ),
      adresse,
    };
  });
}
